module.exports = __webpack_public_path__ + "media/images/lb/797-b6cfad14aefc4323cbe6efba183bf491.svg";